import { useState, useEffect, useCallback } from 'react';
import { FacilityGroupsApi } from '@/api/clients/facility-groups/facility-groups.api';

export const useGetFacilityGroup = (organizationId, groupId) => {
  const [facilityGroup, setFacilityGroup] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFacilityGroup = useCallback(async () => {
    if (!organizationId || !groupId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await FacilityGroupsApi.getFacilityGroup(
        organizationId,
        groupId,
      );
      setFacilityGroup(response.data.data);
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || 'Failed to fetch facility group';
      setError(errorMessage);
      console.error('Error fetching facility group:', err);
    } finally {
      setLoading(false);
    }
  }, [organizationId, groupId]);

  useEffect(() => {
    fetchFacilityGroup();
  }, [fetchFacilityGroup]);

  return {
    facilityGroup,
    loading,
    error,
    refetch: fetchFacilityGroup,
  };
};
